import React, { useState } from 'react';
import './RecognitionTab.css';
import RecognitionOperationsTab from './RecognitionOperationsTab';
import TranscriptionsTab from './TranscriptionsTab';
import UploadTab from './UploadTab';

function RecognitionTab() {
  const [activeSubTab, setActiveSubTab] = useState('transcriptions');

  return (
    <div className="recognition-tab">
      <div className="sub-tabs">
        <button
          className={`sub-tab-button ${activeSubTab === 'upload' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('upload')}
        >
          📤 Загрузка файла
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'operations' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('operations')}
        >
          Операции распознавания
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'transcriptions' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('transcriptions')}
        >
          Результаты распознавания
        </button>
      </div>
      <div className="sub-tab-content">
        {activeSubTab === 'upload' && <UploadTab />}
        {activeSubTab === 'operations' && <RecognitionOperationsTab />}
        {activeSubTab === 'transcriptions' && <TranscriptionsTab />}
      </div>
    </div>
  );
}

export default RecognitionTab;

